<div class="wrap">

  <ng-container *ngIf="showComment; else hideComment">

  <h2>Ajouter un commentaire</h2>

  <form [formGroup]="commentForm" id="commentForm" class="input_google_search" *ngIf="commentForm">

    <mat-form-field appearance="outline">
      <mat-label>Commentaire</mat-label>
      <textarea matInput
      cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="5"
      formControlName="comment"></textarea>
      <mat-error>Le commentaire ne doit pas dépasser 500 caractères.</mat-error>
    </mat-form-field>

  </form>

  </ng-container>

  <ng-template #hideComment>
    <h2>Êtes-vous certain de réserver ce panier ?</h2>
    <p>Le paiement se fera au club.</p>
  </ng-template>



  <div class="btn_action">
    <button type="button" class="back" (click)="dialogRef.close(false)">Annuler</button>
    <button class="confirm" *ngIf="!showComment" (click)="showComment = !showComment">Retour</button>
    <button class="confirm" *ngIf="showComment" form="commentForm" (click)="commentForm.invalid ? null : showComment = !showComment" [style.opacity]="commentForm.invalid? .5 : 1">Suivant</button>
    <button type="submit" class="confirm" *ngIf="!showComment" appChangeColorTheme attribute="bgc" (click)="confirm()">Réserver</button>

  </div>

</div>
